export default {
  computed: {

  },
  methods: {
    getMaquinariaYEquipoPorContrato(idContrato) {
      const inventariosContrato = this.getContratosInventarios
        .filter((i) => i.idContrato === idContrato
        && new Date(`${i.fecha} 00:00:0`) >= new Date(`${this.fechaDelInforme} 00:00:0`)
        && new Date(`${i.fecha} 00:00:0`) <= new Date(`${this.fechaAlInforme} 00:00:0`))
        .map((i) => {
          const insumos = i.insumos.map((item) => ({
            contratoNumero: i.contrato.numero,
            fecha: i.fecha,
            cantidad: item.cantidad,
            descripcion: item.insumo.descripcion,
            orden: item.insumo.orden,
            tipo: item.insumo.tipo,

          }));
          return insumos;
        }).flat(Infinity);

      const inventariosDescripcion = inventariosContrato.map(({ descripcion }) => descripcion);
      const inventariosUnicos = inventariosDescripcion
        .filter((item, index) => inventariosDescripcion.indexOf(item) === index)
        .map((item) => {
          const inventariosFiltrados = inventariosContrato.filter((i) => i.descripcion === item);
          const cantidades = inventariosFiltrados.map(({ cantidad }) => cantidad);
          const cantidadMaxima = Math.max(...cantidades);
          const datosInventario = inventariosContrato.find((i) => i.descripcion === item);
          return ({
            descripcion: item,
            cantidad: cantidadMaxima,
            orden: datosInventario.orden,
            tipo: datosInventario.tipo,
          });
        });

      return inventariosUnicos.sort((a, b) => a.tipo - b.tipo)
        .sort((a, b) => a.orden - b.orden);
    },
    async generarPdfMaquinariaYEquipo() {
      const nombreTemplate = 'templateInformeMaquinariaYEquipo';
      const datosContrato = this.formatoObjeto(this.getContrato);

      const datosFecha = this.formatoObjeto({
        fechaDel: this.fechaDelInforme,
        fechaAl: this.fechaAlInforme,
      });
      const fechaTitulo = `del ${datosFecha.fechaDel_texto.slice(0, datosFecha.fechaDel_texto.length - 7)}
          al ${datosFecha.fechaAl_texto}`;
      const logo = this.getCliente?.logo || '';

      const contratosRelacionados = this.getContrato.contratosRelacionados
        .map((c) => c.contratoRelacionado)
        .sort((a, b) => a.orden - b.orden);

      /* let inventariosRelacionados = this.getContrato.contratosRelacionados
      .map(({ contratoRelacionado }) => ({
        contratista: contratoRelacionado,
        inventarios: this.getMaquinariaYEquipoPorContrato(contratoRelacionado.id),
      })); */

      let inventariosRelacionados = contratosRelacionados
        .map(({ id }) => ({
          contratista: contratosRelacionados
            .find((contratoRelacionado) => contratoRelacionado.id === id),
          inventarios: this.getMaquinariaYEquipoPorContrato(id),
        }));

      const inventariosContrato = {
        contratista: { numero: this.getContrato.numero },
        inventarios: this.getMaquinariaYEquipoPorContrato(this.getContrato.id),
      };

      const tipoContrato = this.getContrato?.obras[0].obra.tipo.descripcion || '';

      if (tipoContrato === 'OBRA') {
        inventariosRelacionados = [];
      }

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: false,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          contrato: datosContrato,
          tipoContrato,
          inventarios: [...inventariosRelacionados],
          inventariosContrato,
          fecha: datosFecha,
          fechaTitulo,
          logo,
          numeroInforme: this.numeroInforme,
          footer: '',
        },
      }, `${this.contrato.numero}_Inventario_${this.fechaDelInforme}_${this.fechaAlInforme}`);
      this.documentoSeleccionado = null;
    },
  },
};
